import React, { Component, Fragment } from "react";
import { withRouter, matchPath } from "react-router-dom";
import CartMenu from "../containers/CartMenu";
import MyAccount from "../containers/MyAccount";
import SearchBar from "./SearchBar";

class ToolBar extends Component {
  constructor(props) {
    super(props);
    this.state = { isSearchFormVisible: false , hideCheckout: false};
    this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
  }

  onSearchClickHandler(openSearchForm) {
    this.setState({ isSearchFormVisible: openSearchForm, hideCheckout: openSearchForm === true });
  }

  isSubCategoryRoute() {
    const { location } = this.props;
    if (!location) return false;
    const path = location.pathname.replace(/\/$/, '').toLowerCase();
    // Match /categories/xx or any deeper sub-level, but not /categories alone
    const match = path.match(/\/categories\/.+/) || path.match(/\/products\/.+/); ///:shopName?/products/:id/
    
    return match !== null;
  }

  render() {
    const { settings, location, history } = this.props;
    const isCatalogueMode = settings && settings.isCatalogueMode === true;
    const isAppMode = settings && settings.isAppMode === true;
    
    const isMainShopRoute = matchPath(location.pathname, {
        path: ["/", `/${settings.shopName}`],
        exact: true,
        strict: false
      });
    const isMobileShowCartRoute = location &&
      (
        isMainShopRoute ||
        location.pathname.toLowerCase().includes('categories') || location.pathname.toLowerCase().includes('products') || 
        location.pathname.toLowerCase().includes('search') || location.pathname.toLowerCase().includes('checkout') ||
        location.pathname.toLowerCase().includes('carts') || location.pathname.toLowerCase().includes('openpay') ||
        location.pathname.toLowerCase().includes('openpay-checkout') || location.pathname.toLowerCase().includes('promotionlist') ||
        location.pathname.toLowerCase().includes('stripelinkpayment')
      );
    const hideCartAppMode = isAppMode && isMobileShowCartRoute === false;
    const hideCart = isCatalogueMode || hideCartAppMode;
    const showBackButton = isAppMode && this.isSubCategoryRoute();
    return (
      <Fragment>
        <SearchBar
          settings={this.props.settings}
          isSearchFormVisible={this.state.isSearchFormVisible}
          onCloseClick={this.onSearchClickHandler}
        />
        {showBackButton && (
          <div className="toolbar-back" onClick={() => history.goBack()}>
            <i className="icon-arrow-left"></i>
          </div>
        )}
        <div className="toolbar">
                <div className="inner">
                    <div className="tools" style={{ height:'100%', display: "flex", alignItems: "center", gap: 12, flexWrap: "nowrap", whiteSpace: "nowrap" }}>
              <div
                className="search mr-2"
                onClick={() => this.onSearchClickHandler(true)}
              >
                <i className="icon-search"></i>
              </div>
              {isCatalogueMode === false && <MyAccount />}
              {hideCart === false && <div style={this.state.hideCheckout ? { display: "none" } : {display: "block"}}><CartMenu /></div>}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(ToolBar);
